import React from 'react';
import BaseModal from '../common/BaseModal';

const CashPaymentModal = ({
  show,
  totalAmount,
  cashReceived,
  setCashReceived,
  cashChange,
  setCashChange,
  onConfirm,
  onCancel
}) => {
  const handleQuickAmount = (amount) => {
    setCashReceived(amount.toString());
    setCashChange(amount - totalAmount);
  };

  const handleCashReceivedChange = (e) => {
    setCashReceived(e.target.value);
    const received = parseFloat(e.target.value) || 0;
    const change = received - totalAmount;
    setCashChange(Math.max(0, change));
  };

  const isValidAmount = cashReceived && parseFloat(cashReceived) >= totalAmount;
  const isTooLow = cashReceived && parseFloat(cashReceived) > 0 && parseFloat(cashReceived) < totalAmount;

  // Standardowe szybkie kwoty (tylko te >= totalAmount)
  const standardAmounts = [10, 20, 50, 100, 200, 500].filter(amount => amount >= totalAmount);

  // Dodaj dokladna kwote jesli nie ma jej w standardowych
  const exactAmount = Math.ceil(totalAmount);
  const quickAmounts = exactAmount > 0 && !standardAmounts.includes(exactAmount) && exactAmount < 500
    ? [exactAmount, ...standardAmounts]
    : standardAmounts;

  const footer = (
    <>
      <button
        data-pos-btn="true"
        onClick={onCancel}
        style={{
          padding: "6px 12px",
          border: "1px solid var(--border)",
          backgroundColor: "var(--card-bg)",
          color: "var(--text-muted)",
          cursor: "pointer",
          fontSize: "12px",
        }}
      >
        Anuluj
      </button>
      <button
        data-pos-btn="true"
        onClick={onConfirm}
        disabled={!isValidAmount}
        style={{
          padding: "6px 12px",
          border: isValidAmount ? "2px solid var(--success)" : "1px solid var(--border)",
          backgroundColor: isValidAmount ? "var(--success)" : "var(--card-bg)",
          color: isValidAmount ? "#fff" : "var(--text-muted)",
          cursor: isValidAmount ? "pointer" : "not-allowed",
          fontSize: "12px",
          fontWeight: "600",
        }}
      >
        <i className="fas fa-check" style={{ marginRight: "0.5rem" }}></i>
        Zaplac
      </button>
    </>
  );

  return (
    <BaseModal
      isOpen={show}
      onClose={onCancel}
      title="Platnosc gotowkowa"
      headerIcon={<i className="fas fa-money-bill-wave" style={{ fontSize: "1rem" }}></i>}
      headerStyle={{ backgroundColor: "var(--success)" }}
      size="sm"
      footer={footer}
    >
      {/* Kwota do zaplaty */}
      <div style={{ marginBottom: "1rem", padding: "0.75rem", backgroundColor: "var(--bg)", borderRadius: "6px" }}>
        <div style={{ fontSize: "0.875rem", color: "var(--text-muted)", marginBottom: "0.25rem" }}>
          Kwota do zaplaty:
        </div>
        <div style={{ fontSize: "1.25rem", fontWeight: "700", color: "var(--success)" }}>
          {totalAmount.toFixed(2)} zl
        </div>
      </div>

      {/* Pole kwoty otrzymanej */}
      <div style={{ marginBottom: "1rem" }}>
        <label style={{ display: "block", marginBottom: "0.5rem", fontSize: "0.875rem", fontWeight: "500" }}>
          Kwota otrzymana:
        </label>
        <input
          type="number"
          step="0.01"
          min="0"
          value={cashReceived}
          onChange={handleCashReceivedChange}
          placeholder="Wpisz otrzymana kwote"
          style={{
            width: "100%",
            padding: "0.75rem",
            border: isTooLow ? "2px solid var(--danger)" : "1px solid var(--border)",
            borderRadius: "6px",
            fontSize: "1rem",
            backgroundColor: isTooLow ? "var(--danger-light)" : "var(--card-bg)" ,
          }}
          autoFocus
        />
        {/* Komunikat o zbyt niskiej kwocie */}
        {isTooLow && (
          <div style={{
            marginTop: "0.5rem",
            padding: "0.5rem 0.75rem",
            backgroundColor: "var(--danger-light)",
            borderRadius: "4px",
            color: "var(--danger)",
            fontSize: "0.875rem",
            display: "flex",
            alignItems: "center",
            gap: "0.5rem"
          }}>
            <i className="fas fa-exclamation-triangle"></i>
            Kwota otrzymana jest za niska! Brakuje: {(totalAmount - parseFloat(cashReceived)).toFixed(2)} zl
          </div>
        )}
      </div>

      {/* Wyswietlenie reszty */}
      {isValidAmount && (
        <div style={{ marginBottom: "1rem", padding: "0.75rem", backgroundColor: "var(--info-light)", borderRadius: "6px" }}>
          <div style={{ fontSize: "0.875rem", color: "var(--info)", marginBottom: "0.25rem" }}>
            Reszta do wydania:
          </div>
          <div style={{ fontSize: "1.5rem", fontWeight: "700", color: "var(--info)" }}>
            {cashChange.toFixed(2)} zl
          </div>
        </div>
      )}

      {/* Przyciski szybkiej kwoty */}
      <div>
        <div style={{ fontSize: "0.75rem", color: "var(--text-muted)", marginBottom: "0.5rem", textTransform: "uppercase" }}>
          Szybkie kwoty:
        </div>
        <div style={{ display: "flex", gap: "0.5rem", flexWrap: "wrap" }}>
          {quickAmounts.map((amount) => {
            const isSelected = cashReceived === amount.toString();
            return (
              <button
                key={amount}
                data-pos-btn="true"
                onClick={() => handleQuickAmount(amount)}
                style={{
                  padding: "6px 12px",
                  border: isSelected ? "2px solid var(--success)" : "1px solid var(--border)",
                  backgroundColor: isSelected ? "var(--success)" : "var(--card-bg)",
                  color: isSelected ? "#fff" : "var(--text-secondary)",
                  fontWeight: isSelected ? "700" : "normal",
                  cursor: "pointer",
                  fontSize: "12px",
                  transition: "all 0.15s ease",
                }}
              >
                {amount} zł
              </button>
            );
          })}
        </div>
      </div>
    </BaseModal>
  );
};

export default React.memo(CashPaymentModal);
